import { useContext, useEffect, useState } from "react";
import MainLayout from "../Container/Layout/MainLayout";
// context
import { Context } from "../Context/Context";
// style
import styles from "../Styles/Ticket.module.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { closeTicket, getTicket } from "../Services/ContectService";
import moment from "jalali-moment";
import swal from "sweetalert";
import QuoteImage from "../Components/Common/QuoteImage";

const Ticket = () => {
  const { json, user, setLoading } = useContext(Context);
  const content = json?.Ticket;
  const [tickets, setTickets] = useState([]);

  const tableCols = [
    {
      title: "شناسه",
      field: "code",
    },
    {
      title: "موضوع",
      field: "subject",
    },
    {
      title: "تصویر",
      field: null,
      element: (rowData) =>
        rowData.service ? (
          <QuoteImage
            code={rowData.service.code}
            className="w-[150px] h-[150px] object-cover  mx-auto 
                    rounded-lg border-2 border-black"
          />
        ) : (
          <img
            src="/imgs/upload/wisercam image.png"
            className="w-[150px] h-[150px] object-cover mx-auto 
                    rounded-lg border-2 border-black"
            alt="Wisercam logo"
          />
        ),
    },
    {
      title: "نوع",
      field: null,
      element: (rowData) => (
        <span>
          {rowData.type === "s"
            ? "مظنه"
            : rowData.type === "o"
            ? "سفارش"
            : rowData.type === "p"
            ? "عمومی"
            : "مشخص نشده"}
        </span>
      ),
    },
    {
      title: "وضعیت",
      field: null,
      element: (rowData) => (
        <span>
          {rowData.status === "o"
            ? content.status_open
            : rowData.status === "c"
            ? content.status_close
            : rowData.status === "a"
            ? content.status_answered
            : ""}
        </span>
      ),
    },
    {
      title: "آخرین به روز رسانی",
      field: null,
      element: (rowData) => (
        <span>
          {moment(rowData.updated_at, "YYYY/MM/DD")
            .locale("fa")
            .format("YYYY/MM/DD")}
        </span>
      ),
    },
    {
      title: "عملیات‌ها",
      field: null,
      element: (rowData) => (
        <div className="flex items-center justify-center gap-2">
          <Link
            to={`/DetailsTicket/${rowData.code}`}
            className="main-btn main-btn-fill"
          >
            {content.button_table1}
          </Link>
          {/*<button
            onClick={() =>
              swalCloseTicketHandeler(rowData.code, rowData.status)
            }
            className="main-btn bg-warning color-white"
          >
            {content.button_table2}
          </button> */}
        </div>
      ),
    },
  ];

  const ticketHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getTicket(user);
      if (status === 200) {
        setTickets(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const closeTicketHandeler = async (id) => {
    setLoading(true);
    try {
      const { status } = await closeTicket(user, id);
      if (status === 200) {
        toast.success(json.toast.ticket);
        setLoading(false);
        setTickets((prevValue) =>
          prevValue.map((item) =>
            item.code === id ? { ...item, status: "c" } : item
          )
        );
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };
  const swalCloseTicketHandeler = async (id, status) => {
    if (status === "c") {
      toast.error("این تیکت قبلا بسته شده است !");
    } else {
      const result = await swal({
        title: json.swal.closeTicket.title,
        text: json.swal.closeTicket.text,
        icon: "warning",
        buttons: {
          cancel: json.swal.closeTicket.button_1,
          yes: json.swal.closeTicket.button_2,
        },
        dangerMode: true,
      });
      if (result) closeTicketHandeler(id);
    }
  };

  useEffect(() => {
    ticketHandeler();
  }, []);

  return (
    <MainLayout>
      <div className="flex flex-col gap-4 px-4 pb-8">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg
              width="40"
              height="46"
              viewBox="0 0 52 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M43.9836 8.15232C40.4481 4.5942 35.9357 2.16594 31.0185 1.17536C26.1013 0.184772 21.0007 0.676473 16.3632 2.58813C11.7258 4.49978 7.7604 7.74531 4.96968 11.9133C2.17895 16.0813 0.688581 20.984 0.6875 26V39.125C0.6875 40.8655 1.3789 42.5347 2.60961 43.7654C3.84032 44.9961 5.50952 45.6875 7.25 45.6875H11C12.7405 45.6875 14.4097 44.9961 15.6404 43.7654C16.8711 42.5347 17.5625 40.8655 17.5625 39.125V29.75C17.5625 28.0095 16.8711 26.3403 15.6404 25.1096C14.4097 23.8789 12.7405 23.1875 11 23.1875H6.50937C7.18813 18.502 9.5316 14.2177 13.1108 11.1188C16.6901 8.01992 21.2656 6.3137 26 6.31247H26.15C30.8633 6.33265 35.4117 8.04912 38.9632 11.1479C42.5147 14.2466 44.8318 18.5204 45.4906 23.1875H41C39.2595 23.1875 37.5903 23.8789 36.3596 25.1096C35.1289 26.3403 34.4375 28.0095 34.4375 29.75V39.125C34.4375 40.8655 35.1289 42.5347 36.3596 43.7654C37.5903 44.9961 39.2595 45.6875 41 45.6875H45.5938C45.3776 46.7463 44.8023 47.6978 43.9652 48.3812C43.1281 49.0646 42.0806 49.4377 41 49.4375H27.875C27.1291 49.4375 26.4137 49.7338 25.8863 50.2612C25.3588 50.7887 25.0625 51.5041 25.0625 52.25C25.0625 52.9959 25.3588 53.7113 25.8863 54.2387C26.4137 54.7662 27.1291 55.0625 27.875 55.0625H41C43.7341 55.0594 46.3553 53.9719 48.2886 52.0386C50.2219 50.1053 51.3094 47.4841 51.3125 44.75V26C51.3254 22.6891 50.6846 19.4083 49.427 16.3456C48.1693 13.283 46.3195 10.4986 43.9836 8.15232ZM11 28.8125C11.2486 28.8125 11.4871 28.9112 11.6629 29.0871C11.8387 29.2629 11.9375 29.5013 11.9375 29.75V39.125C11.9375 39.3736 11.8387 39.6121 11.6629 39.7879C11.4871 39.9637 11.2486 40.0625 11 40.0625H7.25C7.00136 40.0625 6.7629 39.9637 6.58709 39.7879C6.41127 39.6121 6.3125 39.3736 6.3125 39.125V28.8125H11ZM40.0625 39.125V29.75C40.0625 29.5013 40.1613 29.2629 40.3371 29.0871C40.5129 28.9112 40.7514 28.8125 41 28.8125H45.6875V40.0625H41C40.7514 40.0625 40.5129 39.9637 40.3371 39.7879C40.1613 39.6121 40.0625 39.3736 40.0625 39.125Z"
                fill="black"
              />
            </svg>
            <h1 className="font-bold text-3xl">گفتگو و پشتیبانی</h1>
          </div>
          <Link to="/CreateTicket" className="main-btn main-btn-fill">
            گفتگوی عمومی
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 0.5C11.33 0.5 8.71987 1.29176 6.49981 2.77516C4.27974 4.25856 2.54942 6.36697 1.52763 8.83377C0.505849 11.3006 0.238504 14.015 0.759405 16.6337C1.28031 19.2525 2.56606 21.6579 4.45406 23.5459C6.34207 25.434 8.74754 26.7197 11.3663 27.2406C13.985 27.7615 16.6994 27.4942 19.1662 26.4724C21.633 25.4506 23.7414 23.7203 25.2248 21.5002C26.7082 19.2801 27.5 16.67 27.5 14C27.496 10.4208 26.0724 6.98932 23.5416 4.45844C21.0107 1.92756 17.5792 0.50397 14 0.5ZM14 24.5C11.9233 24.5 9.89324 23.8842 8.16652 22.7304C6.4398 21.5767 5.09399 19.9368 4.29927 18.0182C3.50455 16.0996 3.29662 13.9884 3.70176 11.9516C4.10691 9.91475 5.10693 8.04383 6.57538 6.57538C8.04384 5.10693 9.91476 4.1069 11.9516 3.70175C13.9884 3.29661 16.0996 3.50454 18.0182 4.29926C19.9368 5.09399 21.5767 6.4398 22.7304 8.16651C23.8842 9.89323 24.5 11.9233 24.5 14C24.497 16.7839 23.3898 19.4528 21.4213 21.4213C19.4529 23.3898 16.7839 24.497 14 24.5ZM20.5 14C20.5 14.3978 20.342 14.7794 20.0607 15.0607C19.7794 15.342 19.3978 15.5 19 15.5H15.5V19C15.5 19.3978 15.342 19.7794 15.0607 20.0607C14.7794 20.342 14.3978 20.5 14 20.5C13.6022 20.5 13.2206 20.342 12.9393 20.0607C12.658 19.7794 12.5 19.3978 12.5 19V15.5H9.00001C8.60218 15.5 8.22065 15.342 7.93935 15.0607C7.65804 14.7794 7.50001 14.3978 7.50001 14C7.50001 13.6022 7.65804 13.2206 7.93935 12.9393C8.22065 12.658 8.60218 12.5 9.00001 12.5H12.5V9C12.5 8.60218 12.658 8.22064 12.9393 7.93934C13.2206 7.65804 13.6022 7.5 14 7.5C14.3978 7.5 14.7794 7.65804 15.0607 7.93934C15.342 8.22064 15.5 8.60218 15.5 9V12.5H19C19.3978 12.5 19.7794 12.658 20.0607 12.9393C20.342 13.2206 20.5 13.6022 20.5 14Z"
                fill="white"
              />
            </svg>
          </Link>
        </div>

        <div
          className="w-full overflow-x-auto overflow-y-hidden 
                border-[1px] border-black rounded-lg"
        >
          {tickets.length > 0 ? (
            <table className="w-full min-w-[800px]">
              <thead className="border-b-2 border-b-black bg-[#DFE6FF] text-black">
                <tr className="text-center [&>th]:py-3 [&>th]:px-2">
                  {tableCols.map((col, index) => (
                    <th key={`th_${index}`}>{col.title}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="text-center [&>tr:nth-child(2n)]:bg-[#D9D9D94A] align-middle">
                {tickets.map((item, index) => (
                  <tr
                    className="text-center font-bold
                                        [&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-black 
                                        [&>td]:py-3 [&>td]:px-2"
                    key={`tr_${index}`}
                  >
                    {tableCols.map((col, index) => (
                      <td
                        key={`td_${index}`}
                        className={`${index === 0 ? "relative" : ""}`}
                      >
                        {item[col.field] ? item[col.field] : col.element(item)}
                        {index === 0 && !item.is_read && (
                          <span
                            className="absolute w-[10px] h-full
                                                    top-0 right-0 bg-[#0038FF]"
                          ></span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>{json.notfound}</p>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default Ticket;
